import React from 'react';
import SquareButton from '../button/SquareButton';
import CircleButton from '../button/CircleButton';
import './MapToggleBtns.css';
import { mapType } from '../../types';
export type MapToggleBtnsColorType = 'blue' | 'red' | 'light-blue' | 'light-red';

export type MapToggleBtnsPropsType = {
    dataList: { label: string, value: mapType, color?: MapToggleBtnsColorType, selectedColor?: MapToggleBtnsColorType }[];
    setValue: (val: mapType) => void;
    value: mapType;
    small?: boolean;
    type?: 'square' | 'round';
}

const MapToggleBtns: React.FC<MapToggleBtnsPropsType> = ({dataList, setValue, value, small, type}) => {
    
    return (
        <div className='toggle-buttons'>
            {dataList.map((data, index) => {

                return (
                    type === 'square' ?
                    <SquareButton 
                        onClick={() => setValue(data.value)} 
                        label={data.label} 
                        small={small} 
                        key={index}
                        color={ data.value === value ? data.selectedColor : data.color }
                        bold={ data.value === value }
                    />
                    :
                    <CircleButton 
                        onClick={() => setValue(data.value)} 
                        label={data.label} 
                        small={small} 
                        key={index}
                        color={ data.value === value ? data.selectedColor : data.color }
                        bold={ data.value === value }
                    />
                );
            })}
        </div>
    );
};

export default MapToggleBtns;
